import { Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AppearanceService implements OnDestroy {
  private colorDrawSubject: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultColor);
  private colorTypeSubject: BehaviorSubject<string> = new BehaviorSubject<string>(this.defaultColor);

  constructor() {}

  public ngOnDestroy(): void {
    this.colorDrawSubject.complete();
    this.colorTypeSubject.complete();
  }

  get defaultColor(): string {
    return '#404040FF';
  }

  public currentDrawColor(): Observable<string> {
    return this.colorDrawSubject.asObservable();
  }

  public setNewDrawColor(color: string): void {
    this.colorDrawSubject.next(color);
  }

  public currentTypeColor(): Observable<string> {
    return this.colorTypeSubject.asObservable();
  }

  public setNewTypeColor(color: string): void {
    this.colorTypeSubject.next(color);
  }

  public test() {
    console.log('test');
  }
}
